import services from 'app/services';
import { message } from 'antd';

export const apiGetNotifications = async ( id ) => {
    try {
        const data = await services.notification.getNotifications();
        return data;
    } catch ( error ) {
        console.error( 'apiGetNotifications failed', error );
        message.error( `An error occurred: ${ error }` );
        throw new Error( error );
    }  
};